'use strict';

angular.module('webAgro1App').controller('DepositosCtrl', function($location, $scope, $rootScope, DepositosService, Flash, LoadingService, MessagesService) {

  $scope.depositos = [];
  $scope.tipoDepositos = [
    {id: 'proprio', descricao: 'Próprio'},
    {id: 'terceiro', descricao: 'Terceiros'}
  ];

  $scope.filters = {
    tipoDeposito: $scope.tipoDepositos[0]
  };

  var initialize = function() {
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.depositos.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.listAll();
    }, $rootScope.errorRootInitialize);
  };

  $scope.listAll = function() {
    LoadingService.showLoading();
    DepositosService.list($scope.filters).then(function(data){
      $scope.depositos = data.data || [];
    }, function() {
      MessagesService.alert('Não foi possível buscar os depósitos.');
    }).finally(LoadingService.hideLoading);
  };

  initialize();

  $scope.buscarClick = function() {
    LoadingService.showLoading();
    $scope.depositos = [];
    DepositosService.list($scope.filters).then(function(data){
      $scope.depositos = data.data || [];
    }, function() {
      MessagesService.alert('Não foi possível buscar o depósito.');
    }).finally(LoadingService.hideLoading);
  };

  $scope.show = function(index) {
    var deposito = $scope.depositos[index];

    if (deposito) {
      $location.path('/depositos/' + deposito.cd_deposito);
    }
  };
});
